export const GET_METRICS_REQUEST = 'GET_METRICS_REQUEST';
export const GET_METRICS_SUCCESS = 'GET_METRICS_SUCCESS';
export const GET_METRICS_FAILURE = 'GET_METRICS_FAILURE';